import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  sidebarOpen: {
    overflow: "hidden"
  }
}));

export default useStyles;